import { ref, computed } from 'vue'

/**
 * Configuración global para el sistema de notificaciones.
 * El cliente debe setear esta configuración antes de usar las notificaciones.
 */
export interface ConfigNotificaciones {
  apiUrl: string
  dispositivo: 'web' | 'ios' | 'android'
  version?: string
  buildTimestamp?: string
}

const configRef = ref<ConfigNotificaciones | null>(null)

export const configNotificaciones = computed(() => configRef.value)

export function setConfigNotificaciones(config: ConfigNotificaciones) {
  configRef.value = config
}

export function getConfigNotificaciones(): ConfigNotificaciones {
  if (!configRef.value) {
    throw new Error('[configNotificaciones] Configuración no establecida. Llama a setConfigNotificaciones() antes de usar el sistema de notificaciones.')
  }
  return configRef.value
}
